import { render, staticRenderFns } from "./InvoicePaxesTable.vue?vue&type=template&id=98ee0b80&"
import script from "./InvoicePaxesTable.vue?vue&type=script&lang=js&"
export * from "./InvoicePaxesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports